import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL, privilegeURL, privilegeURLV2 } from "../../../service/API.js";
import Switch from "@material-ui/core/Switch";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import TextField from "@material-ui/core/TextField";


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  inputColor: {
    backgroundColor: "#F4F6F9",
    borderRadius: "5px",
    borderWidth: "0",
  },
}));

export const CreateSpecialCampaign = (props) => {
  const { user, authToken, accessTokenPrivilege } = useSelector((state) => state.auth);

  const intl = useIntl();
  const suhbeader = useSubheader();
  const classes = useStyles();
  suhbeader.setTitle(intl.formatMessage({ id: "###", defaultMessage: "Create Special Campaign Group" }));
  const history = useHistory();

  const [start_date, setStart_date] = useState('');
  const [end_date, setEnd_date] = useState('');

  const [type, setType] = useState('Earn');
  const [list, setList] = useState('Birthday');
  const [event, setEvent] = useState(null);
  const [listEvent, setListEvent] = useState([]);
  const [target, setTarget] = useState(null);
  const [listTarget, setListTarget] = useState([]);
  const [privilege, setPrivilege] = useState(0);
  const [listPrivilege, setListPrivilege] = useState([]);
  const [privilegePoint, setPrivilegePoint] = useState(0);
  const [typePoint, setTypePoint] = useState(0);
  const [reducePoint, setReducePoint] = useState(0);
  const [campaign, setCampaign] = useState('');
  const [description, setDescription] = useState('');
  const [plusPoint, setPlusPoint] = useState(0);
  const [multiplePoint, setMultiplePoint] = useState(0);
  const [normalPoint, setNormalPoint] = useState();
  const [symbolsArr] = useState(["e", "E", "+", "-"])

  const [listGroup, setListGroup] = useState({
    Earn: [
      {
        name: 'Birthday'
      },
      {
        name: 'Birth Month'
      },
      {
        name: 'Special Point'
      },
      {
        name: 'First Time Login'
      },
    ],
    Burn: [
      {
        name: 'Discount Point'
      },
    ],

  })


  const AlertError = (message) => {
    Swal.fire("Item key!", message, "error");
  };

  const getListEvent = async () => {
    const apiUrls = `${baseURLV1}/eventType?page=1&limit=1000`;
    let token = localStorage.getItem("token");

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        // console.log(res.data.data)
        setListEvent(res.data.data)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };

  const getListTarget = async () => {
    const apiUrls = `${baseURLV1}/targetGroup?page=1&limit=1000`;
    let token = localStorage.getItem("token");

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        // console.log(res.data.data)
        setListTarget(res.data.data)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };

  const getListPrivilege = async () => {
    axios({
      method: "get",
      url: `${privilegeURLV2}/deal?page=1&limit=1000&campaign_id=22`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessTokenPrivilege}`,
      },
    }).then((res) => {
      if (res.message) {
        //history.push("/logout");
      } else {
        // console.log(res.data.data);
        setListPrivilege(res.data.data)
      }
    }).catch((err) => {
      //window.location.assign("/logout");
    });
  };

  const getStartData = async () => {
    await getListEvent()
    await getListTarget()
    await getListPrivilege()
  }

  const handlePrivilegePoint = async (id, list = listPrivilege) => {
    setPrivilege(id)
    setReducePoint(0)
    let result = await list.find(item => item.id == id)
    console.log(result);
    if (result) {
      await setPrivilegePoint(result.point)
    }
  }

  const handleSetType = async (data) => {
    if (data != type) {
      setEvent(null);
      setTarget(null);
      setPrivilege(0);
      setPrivilegePoint(0);
      setTypePoint(0);
      setCampaign('');
      setDescription('');
      setPlusPoint(0);
      setMultiplePoint(0);
      setReducePoint(0);
      setType(data)
      if (data == 'Earn') {
        setList('Birthday');
      } else {
        setList('Discount Point');
      }
    }
  }

  const handleSetList = async (data) => {
    if (data != list) {
      setList(data)
      if (data == "Birth Month" || data == "First Time Login") {
        setTypePoint(0)
      }
    }
  }

  const handleSetTypePoint = async (data) => {
    if (data != typePoint) {
      setTypePoint(data)
      setPlusPoint(0);
      setMultiplePoint(0);
      setReducePoint(0);
    }
  }

  const handleRegEx = async (data) => {
    let regEx;

    if (data != typePoint) {
      setTypePoint(data)
      setPlusPoint(0);
      setMultiplePoint(0);
      setReducePoint(0);
    }
  }


  useEffect(() => {
    getStartData()
  }, []);

  /*const handleChangeGroup = (event) => {
    console.log(event.target.value)
    setgroupID(event.target.value);
  };

  const handleChangeProduct = (event) => {
    console.log(event.target.value)
    setproductID(event.target.value);
  };*/

  const onSubmit = async () => {
    let dateFrom = {}
    let dateTo = {}
    // if (type == undefined || type == '') {
    //   return AlertError("กรุณาใส่ type !!");
    // }
    // if (list == undefined || list == '') {
    //   return AlertError("กรุณาใส่ list !!");
    // }

    if (type == 'Earn') {
      if (campaign == undefined || campaign == '') {
        return AlertError("กรุณาใส่ ชื่อแคมเปญ !!");
      }

      if (description == undefined || description == '') {
        return AlertError("กรุณาใส่ รายละเอียดแคมเปญ !!");
      }

      if (typePoint == 0) {
        if (plusPoint < 1 || plusPoint == "") {
          return AlertError("กรุณาใส่ จำนวนคะแนนที่ปรับเพิ่ม มากกว่า 0 !!");
        }
      } else {
        if (multiplePoint < 2 || multiplePoint > 10 || multiplePoint == '') {
          return AlertError("กรุณาใส่ จำนวนคะแนนที่คูณเพิ่ม (เท่า) มากกว่า 1 และน้อยกว่า 10 !!");
        }
      }

    } else if (type == 'Burn') {
      if (campaign == undefined || campaign == '') {
        return AlertError("กรุณาใส่ ชื่อแคมเปญ !!");
      }

      if (description == undefined || description == '') {
        return AlertError("กรุณาใส่ รายละเอียดแคมเปญ !!");
      }
      if (privilege == undefined || privilege == '') {
        return AlertError("กรุณาใส่ privilege !!");
      }

      if (reducePoint < 1) {
        return AlertError("กรุณาใส่ จำนวนคะแนนที่ปรับลด มากกว่า 0 !!");
      }
    }

    if (start_date == undefined || start_date == '') {
      return AlertError("กรุณาใส่ วันที่เริ่มแคมเปญ !!");
    } else if (start_date != '') {
      dateFrom = {
        start_date: start_date
      }
    }
    if (end_date == undefined || end_date == "") {
      return AlertError("กรุณาใส่ วันที่สิ้นสุดแคมเปญ !!");
    } else if (end_date != '') {
      dateTo = {
        end_date: end_date
      }
    }
    // return console.log({type: type, list: list, 'typePoint': typePoint, 'plusPoint': plusPoint, 'multiplePoint': multiplePoint, "start_date": start_date, 'end_date': end_date});

    var events = {}

    if (type == 'Earn') {
      events = {
        type: type,
        campaign_type: list,
        event_type_id: event == '' ? null : event,
        group_condition_id: target == '' ? null : target,
        title_th: campaign,
        title_en: campaign,
        description_th: description,
        description_en: description,
        plus_point: plusPoint == 0 ? null : plusPoint,
        multiple_point: multiplePoint == 0 ? null : (Number(multiplePoint)),
        ...dateFrom,
        ...dateTo,
      };
    } else if (type == 'Burn') {
      events = {
        type: type,
        title_th: campaign,
        title_en: campaign,
        description_th: description,
        description_en: description,
        campaign_type: list,
        privilege_id: privilege,
        event_type_id: event == '' ? null : event,
        reduce_point: reducePoint,
        group_condition_id: target == '' ? null : target,
        ...dateFrom,
        ...dateTo
      };
    }



    let apiUrls = `${baseURLV1}/specialCampaign`;
    let token = localStorage.getItem("Token");
    const resultAll = axios({
      method: "post",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Alert",
          "ไม่สามารถสร้าง Target Group. !! " + err,
          "error"
        );
      });
  };

  console.log(privilegePoint);
  return (
    <>
      <Card>
        <CardHeader title="Create Special Campaign Group"></CardHeader>
        <CardBody>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "ประเภทแคมเปญ" })}:{" "}
            </p>
            <select name="cars" id="cars"
              value={type}
              onChange={(e) => {
                handleSetType(e.target.value)
              }}
            >
              <option value='Earn'>
                Earn
              </option>
              <option value='Burn'>
                Burn
              </option>


            </select>
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "รายการแคมเปญ" })}:{" "}
            </p>
            <select name="cars" id="cars"
              value={list}
              onChange={(e) => {
                handleSetList(e.target.value)
              }}
            >
              {listGroup[type] &&
                listGroup[type].map((result, index) => {
                  return (
                    <option key={index} value={result.name}>
                      {result.name}
                    </option>
                  );
                })}

            </select>
          </div>

          {type == 'Earn' && list != 'Birth Month' && list != 'First Time Login' && <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "ประเภทอีเว้นท์" })}:{" "}
            </p>
            <select name="cars" id="cars"
              style={{ width: "530px" }}
              value={event}
              onChange={(e) => {
                // console.log(e.target.value)
                console.log(e.target.value)
                if (e.target.value != 'All') {
                  setEvent(e.target.value)

                  setNormalPoint(listEvent.filter(item => item.id == e.target.value)[0].point)
                } else {
                  setEvent('')

                  setNormalPoint(null)
                }
              }}
            >
              <option value={null}>
                All
              </option>
              {listEvent &&
                listEvent.map((result, index) => {
                  return (
                    <option key={index} value={result.id}>
                      {result.description_th}
                    </option>
                  );
                })}

            </select>
          </div>}

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "กลุ่มเป้าหมาย" })}:{" "}
            </p>
            <select name="cars" id="cars"
              style={{ width: "530px" }}
              value={target}
              onChange={(e) => {
                // console.log(e.target.value)
                setTarget(e.target.value)
              }}
            >
              <option value={null}>
                All
              </option>
              {listTarget &&
                listTarget.map((result, index) => {
                  return (
                    <option key={index} value={result.id}>
                      {result.title_th}
                    </option>
                  );
                })}

            </select>
          </div>

          {type == 'Burn' && <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "เลือกรีวอร์ด" })}<span style={{ color: "red" }}>
                *
              </span>:{" "}
            </p>
            <select name="cars" id="cars"
              style={{ width: "530px" }}
              value={privilege}
              onChange={(e) => {
                // console.log(e.target.value)
                handlePrivilegePoint(e.target.value)
              }}
            >
              <option value={0} hidden>
                กรุณาเลือก
              </option>
              {listPrivilege &&
                listPrivilege.map((result, index) => {
                  return (
                    <option key={index} value={result.id}>
                      {result.deal_name}
                    </option>
                  );
                })}

            </select>
          </div>}

          {type == 'Burn' && <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "จำนวนคะแนนปกติ" })}:{" "}
            </p>
            <input
              disabled
              type='number'
              onKeyDown={e => symbolsArr.includes(e.key) && e.preventDefault()}

              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={privilegePoint}
            />
          </div>}

          {type == 'Burn' && <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "จำนวนคะแนนที่ปรับลด" })}<span style={{ color: "red" }}>
                *
              </span>:{" "}
            </p>
            <input
              max={privilegePoint}
              type='number'
              onKeyDown={e => symbolsArr.includes(e.key) && e.preventDefault()}
              name="modelGroup"
              min={1}
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={reducePoint}
              onChange={(e) => {
                // if(e.target.value > 0) {
                if (e.target.value <= privilegePoint && e.target.value >= 0) {
                  setReducePoint(e.target.value)
                }
                // handleRegEx(e.target.value, 'setReducePoint')
                // }
              }}
            />
          </div>}

          {type == 'Burn' && privilege != 0 && <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "จำนวนคะแนนหลังปรับลด" })}:{" "}
            </p>
            <input
              disabled
              type='number'
              onKeyDown={e => symbolsArr.includes(e.key) && e.preventDefault()}

              name="modelGroup"
              min={1}
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={privilegePoint - reducePoint}
              onChange={(e) => {
                // if(e.target.value > 0) {
                setReducePoint(e.target.value)
                // handleRegEx(e.target.value, 'setReducePoint')
                // }
              }}
            />
          </div>}

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "ชื่อแคมเปญ" })}<span style={{ color: "red" }}>
                *
              </span>:{" "}
            </p>
            <input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={campaign}
              onChange={(e) => setCampaign(e.target.value)}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "รายละเอียดแคมเปญ" })}<span style={{ color: "red" }}>
                *
              </span>:{" "}
            </p>
            <input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          {type == 'Earn' && <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "รูปแบบการปรับเพิ่ม" })}:{" "}
            </p>
            <select name="cars" id="cars"
              value={typePoint}
              onChange={(e) => {
                handleSetTypePoint(e.target.value)
              }}
            >
              <option value="0">
                จำนวนคะแนนที่ปรับเพิ่ม
              </option>
              {list != "Birth Month" && list != 'First Time Login' && <option value="1">
                จำนวนคะแนนที่คูณเพิ่ม (เท่า)
              </option>}
            </select>
          </div>}

          {normalPoint > 0 && type == 'Earn' && <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "จำนวนคะแนน" })}<span style={{ color: "red" }}>

              </span>:{" "}
            </p>
            <input
              type='number'
              onKeyDown={e => symbolsArr.includes(e.key) && e.preventDefault()}
              disabled
              name="modelGroup"

              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={normalPoint}
            />
          </div>}

          {typePoint == 0 && type == 'Earn' && <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "จำนวนคะแนนที่ปรับเพิ่ม" })}<span style={{ color: "red" }}>
                *
              </span>:{" "}
            </p>
            <input
              type='number'
              onKeyDown={e => symbolsArr.includes(e.key) && e.preventDefault()}

              name="modelGroup"
              min={1}
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={plusPoint}
              onChange={(e) => {
                // if(e.target.value > 0) {
                setPlusPoint(e.target.value)
                // handleRegEx(e.target.value, 'setPlusPoint')
                // }
              }}
            />
          </div>}

          {list != "Birth Month" && list != 'First Time Login' && typePoint == 1 && type == 'Earn' && <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "จำนวนคะแนนที่คูณเพิ่ม (เท่า)" })}<span style={{ color: "red" }}>
                *
              </span>:{" "}
            </p>
            <input
              type='number'
              onKeyDown={e => symbolsArr.includes(e.key) && e.preventDefault()}

              name="modelGroup"
              min={1}
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={multiplePoint}
              onChange={(e) => {
                // if(e.target.value > 0) {
                setMultiplePoint(e.target.value)
                // handleRegEx(e.target.value, 'setMultiplePoint')
                // }
              }}
            />
          </div>}

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "วันที่เริ่มแคมเปญ" })}<span style={{ color: "red" }}>
                *
              </span>:{" "}
            </p>
            {/*<div className="form-inline" style={{ marginBottom: "25px" }}>
              <input id="datestart" type="datetime-local" defaultValue="yyyy-mm-dd" style={{ height: "38px", width: "185px", backgroundColor: "#F4F6F9", borderRadius: "5px", borderWidth: "0" }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(data) =>
                  setStart_date(data.target.value === "NULL" ? null : data.target.value)
                }
              />
            </div>*/}
            <TextField
              //disabled={!(!claimNoRef && !isSubmit) || is_reference}
              id="DateFrom"
              type="datetime-local"
              //label={intl.formatMessage({ id: "###", defaultMessage: " " })}
              className=" mb-3 mr-3"
              value={start_date}
              InputProps={{ inputProps: { min: (new Date).toISOString().slice(0, 16) } }}
              style={{
                height: '15px',
                //width: '20px',
                backgroundColor: '#F4F6F9',
                borderRadius: '5px',
                borderWidth: '0'
              }}
              InputLabelProps={{
                shrink: true
              }}
              onChange={name => {
                setStart_date(name.target.value)
              }}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "วันที่สิ้นสุดแคมเปญ" })}<span style={{ color: "red" }}>
                *
              </span>:{" "}
            </p>
            {/*<div className="form-inline" style={{ marginBottom: "25px" }}>
              <input id="datestart" type="datetime-local" defaultValue="yyyy-mm-dd" style={{ height: "38px", width: "185px", backgroundColor: "#F4F6F9", borderRadius: "5px", borderWidth: "0" }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(data) =>
                  setEnd_date(data.target.value === "NULL" ? null : data.target.value)
                }
              />
            </div>*/}
            <TextField
              //disabled={!(!claimNoRef && !isSubmit) || is_reference}
              id="DateFrom"
              type="datetime-local"
              //label={intl.formatMessage({ id: "###", defaultMessage: " " })}
              className=" mb-3 mr-3"
              value={end_date}
              InputProps={{ inputProps: { min: (new Date).toISOString().slice(0, 16) } }}
              style={{
                height: '15px',
                //width: '20px',
                backgroundColor: '#F4F6F9',
                borderRadius: '5px',
                borderWidth: '0'
              }}
              InputLabelProps={{
                shrink: true
              }}
              onChange={name => {
                setEnd_date(name.target.value)
              }}
            />
          </div>





          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/SpecialCampaign">
              <button type="button" className="btn btn-secondary wbt mr-5">
                {intl.formatMessage({ id: "###", defaultMessage: "Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => onSubmit()}>
              {intl.formatMessage({ id: "###", defaultMessage: "Save" })}
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
